export default __webpack_public_path__ + "static/media/도시농부 클래스_웹.339f36a6.jpg";